import { Controller } from "@hotwired/stimulus"

// Shows/hides per-command sections of the new-run form based on the
// currently selected command. Each section declares which commands it
// applies to via `data-commands="upload_model score"`. Sections without
// the attribute are always visible.
//
// Targets:
//   select   — the command <select>
//   section  — repeated; one per conditional section

const MODEL_REQUIRED_FOR = ["upload_model", "prepare_features", "refresh_features", "score"]

export default class extends Controller {
  static targets = ["select", "section", "modelSelect", "modelRequired"]

  connect() {
    this.toggle()
  }

  toggle() {
    const cmd = this.selectTarget.value
    this.sectionTargets.forEach((el) => {
      const allowed = (el.dataset.commands || "").split(/\s+/).filter(Boolean)
      const visible = allowed.length === 0 || allowed.includes(cmd)
      el.classList.toggle("hidden", !visible)
      el.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !visible
      })
    })

    if (this.hasModelSelectTarget) {
      const required = MODEL_REQUIRED_FOR.includes(cmd)
      this.modelSelectTarget.required = required
      if (this.hasModelRequiredTarget) {
        this.modelRequiredTarget.classList.toggle("hidden", !required)
      }
    }
  }
}
